import Button from '../../button/Button';
import Modal from '../../modal/Modal';

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  allowButtonClosed: boolean;
  handleStartCharging: () => void;
  isLoading?: boolean;
  onClose?: () => void;
}

const ToastChargerUnavailable: React.FC<Props> = ({
  isModalOpen,
  onClose,
  isLoading,
  setIsModalOpen,
  allowButtonClosed,
  handleStartCharging,
}) => {
  return (
    <>
      <Modal
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={onClose}
        textEnterButton='Tentar novamente'
        handleEnterButton={handleStartCharging}
        isLoadingEnterButton={isLoading}
        title='Carregador indisponível'
      >
        <p>O carregador está indisponível ou em uso para iniciar a recarga.</p>
      </Modal>
    </>
  );
};

export default ToastChargerUnavailable;
